var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, AbortableReadEventListener, CloseEventListener, ReadEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class BarcodeAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
        this.onReadFailure = new ReadEventListener();
        this.onReadSuccess = new AbortableReadEventListener();
    }
    /**
     * Gets the expression of the camera input.
     */
    getCameraInputExpression() {
        return this.state.cameraInputExpression;
    }
    /**
     * Updates the expression of the camera input.
     *
     * @param cameraInputExpression - The expression of the camera input.
     */
    setCameraInputExpression(cameraInputExpression) {
        this.setState({ cameraInputExpression });
    }
    /**
     * Gets the camera not supported expression.
     */
    getCameraNotSupportedExpression() {
        return this.state.cameraNotSupportedExpression;
    }
    /**
     * Updates the camera not supported expression.
     *
     * @param cameraInputExpression - The camera not supported expression.
     */
    setCameraNotSupportedExpression(cameraNotSupportedExpression) {
        this.setState({ cameraNotSupportedExpression });
    }
    /**
     * Gets the expression of the camera strip top title.
     */
    getCameraStripTopTitleExpression() {
        return this.state.cameraStripTopTitleExpression;
    }
    /**
     * Updates the expression of the camera strip top title.
     *
     * @param cameraStripTopTitleExpression - The expression of the camera strip top title.
     */
    setCameraStripTopTitleExpression(cameraStripTopTitleExpression) {
        this.setState({ cameraStripTopTitleExpression });
    }
    /**
     * Gets the manual barcode input max length.
     */
    getManualInputMaxLength() {
        return this.state.manualInputMaxLength;
    }
    /**
     * Updates the manual barcode input max length.
    *
    * @param cameraStripTopTitleExpression - The manual barcode input max length.
    */
    setManualInputMaxLength(manualInputMaxLength) {
        this.setState({ manualInputMaxLength });
    }
    /**
     * Closes the barcode modal.
     */
    close() {
        if (!this.state.open) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.onClose.fire();
            this.setState({ open: false });
        }
    }
    /**
     * Gets the barcode data.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Updates barcode data.
     *
     * @param data - The barcode data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Gets the barcode default read type.
     */
    getDefaultReadType() {
        return this.state.defaultReadType;
    }
    /**
     * Updates the barcode default read type.
     *
     * @param defaultReadType - The barcode default read type.
     */
    setDefaultReadType(defaultReadType) {
        this.setState({ defaultReadType });
    }
    /**
     * Gets if the barcode reader is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Updates if the barcode reader is enabled.
     *
     * @param enabled - If the barcode reader is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Gets if the barcode has a description.
     */
    hasDescription() {
        return this.state.hasDescription;
    }
    /**
     * Updates if the barcode has a description.
     *
     * @param hasDescription - If the barcode has a description.
     */
    setHasDescription(hasDescription) {
        this.setState({ hasDescription });
    }
    /**
     * Gets the expression of the infrared input.
     */
    getInfraredInputExpression() {
        return this.state.infraredInputExpression;
    }
    /**
     * Updates the expression of the infrared input.
     *
     * @param infraredInputExpression - The expression of the infrared input.
     */
    setInfraredInputExpression(infraredInputExpression) {
        this.setState({ infraredInputExpression });
    }
    /**
     * Gets the expression of the infrared not supported message.
     */
    getInfraredNotSupportedExpression() {
        return this.state.infraredNotSupportedExpression;
    }
    /**
     * Updates the expression of the infrared not supported message.
     *
     * @param infraredNotSupportedExpression - The expression for the infrared not supported message.
     */
    setInfraredNotSupportedExpression(infraredNotSupportedExpression) {
        this.setState({ infraredNotSupportedExpression });
    }
    /**
     * Gets the expression of the manual barcode input.
     */
    getManualInputBarcodeExpression() {
        return this.state.manualInputBarcodeExpression;
    }
    /**
     * Updates the expression of the manual barcode input.
     *
     * @param manualInputBarcodeExpression - The expression of the manual barcode input.
     */
    setManualInputBarcodeExpression(manualInputBarcodeExpression) {
        this.setState({ manualInputBarcodeExpression });
    }
    /**
     * Gets the expression of the manual description input.
     */
    getManualInputDescriptionExpression() {
        return this.state.manualInputDescriptionExpression;
    }
    /**
     * Updates the expression of the manual description input.
     *
     * @param manualInputDescriptionExpression - The expression of the manual description input.
     */
    setManualInputDescriptionExpression(manualInputDescriptionExpression) {
        this.setState({ manualInputDescriptionExpression });
    }
    /**
     * Gets the expression of the manual input.
     */
    getManualInputExpression() {
        return this.state.manualInputExpression;
    }
    /**
     * Updates the expression of the manual input.
     *
     * @param manualInputExpression - The expression of the manual input.
     */
    setManualInputExpression(manualInputExpression) {
        this.setState({ manualInputExpression });
    }
    /**
     * Gets the expression of the manual reason empty result.
     */
    getManualInputReasonEmptyResultExpression() {
        return this.state.manualInputReasonEmptyResultExpression;
    }
    /**
     * Updates the expression of the manual reason empty result.
     *
     * @param manualInputReasonEmptyResultExpression - The expression of the manual reason empty result.
     */
    setManualInputReasonEmptyResultExpression(manualInputReasonEmptyResultExpression) {
        this.setState({ manualInputReasonEmptyResultExpression });
    }
    /**
     * Gets the expression of the manual reason input.
     */
    getManualInputReasonExpression() {
        return this.state.manualInputReasonExpression;
    }
    /**
     * Updates the expression of the manual reason input.
     *
     * @param manualInputReasonExpression - The expression of the manual reason input.
     */
    setManualInputReasonExpression(manualInputReasonExpression) {
        this.setState({ manualInputReasonExpression });
    }
    /**
     * Gets the expression of the manual reason input placeholder.
     */
    getManualInputReasonPlaceholderExpression() {
        return this.state.manualInputReasonPlaceholderExpression;
    }
    /**
     * Updates the expression of the manual reason input placeholder.
     *
     * @param manualInputReasonPlaceholderExpression - The manual reason input placeholder.
     */
    setManualInputReasonPlaceholderExpression(manualInputReasonPlaceholderExpression) {
        this.setState({ manualInputReasonPlaceholderExpression });
    }
    /**
     * Gets the expression of the manual submit input.
     */
    getManualInputSubmitExpression() {
        return this.state.manualInputSubmitExpression;
    }
    /**
     * Updates the expression of the manual submit input.
     *
     * @param manualInputSubmitExpression - The expression of the manual submit input.
     */
    setManualInputSubmitExpression(manualInputSubmitExpression) {
        this.setState({ manualInputSubmitExpression });
    }
    /**
     * Gets if the barcode reader modal is open.
     */
    isOpen() {
        return this.state.open;
    }
    /**
     * Updates if the barcode reader modal is open.
     *
     * @param cameraInputExpression - If the barcode reader modal is open.
     */
    setOpen(open) {
        this.setState({ open });
    }
    /**
     * Gets the expression of open reader button.
     */
    getOpenReaderExpression() {
        return this.state.openReaderExpression;
    }
    /**
     * Updates the expression of open reader button.
     *
     * @param openReaderExpression - The expression of open reader button.
     */
    setOpenReaderExpression(openReaderExpression) {
        this.setState({ openReaderExpression });
    }
    /**
     * Gets if the description is required.
     */
    getRequireDescription() {
        return this.state.requireDescription;
    }
    /**
     * Updates if the description is required.
     *
     * @param requireDescription - If the description is required.
     */
    setRequireDescription(requireDescription) {
        this.setState({ requireDescription });
    }
    /**
     * Gets if the reason is required.
     */
    getRequireReason() {
        return this.state.requireReason;
    }
    /**
     * Updates if the reason is required.
     *
     * @param requireReason - If the reason is required.
     */
    setRequireReason(requireReason) {
        this.setState({ requireReason });
    }
    /**
     * Gets if the camera is supported.
     */
    getSupportCamera() {
        return this.state.supportCamera;
    }
    /**
     * Updates if the camera is supported.
     *
     * @param supportCamera - If the camera is supported.
     */
    setSupportCamera(supportCamera) {
        this.setState({ supportCamera });
    }
    /**
     * Gets if the infrared is supported.
     */
    getSupportInfrared() {
        return this.state.supportInfrared;
    }
    /**
     * Updates if the infrared is supported.
     *
     * @param supportInfrared - If the infrared is supported.
     */
    setSupportInfrared(supportInfrared) {
        this.setState({ supportInfrared });
    }
    /**
     * Gets the barcode button theme.
     */
    getButtonTheme() {
        return this.state.buttonTheme;
    }
    /**
     * Updates the barcode button theme.
     *
     * @param buttonTheme - The barcode button theme.
     */
    setButtonTheme(buttonTheme) {
        this.setState({ buttonTheme });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BarcodeAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BarcodeAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BarcodeAPI.prototype, "onReadFailure", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BarcodeAPI.prototype, "onReadSuccess", void 0);
export { BarcodeAPI, };
//# sourceMappingURL=barcode-api.js.map